import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import { Link, withRouter } from "react-router-dom";

import Header from "../../components/Header";
import Sidebar from "../../components/Sidebar";
import MainContainer from "../../components/MainContainer";
import AgentActRoster from "../../components/agent/AgentActRoster";
import InvitedActsTable from "../../components/agent/InvitedActsTable";
import ApplyToPlayTable from "../../components/agent/ApplyToPlayTable";
import { Tabs, Tab, Hidden, Badge, AppBar } from "@material-ui/core";
import Paper from "@material-ui/core/Paper";
import Loading from "../../components/loadingSpinner/Loading";
import { Button } from "@material-ui/core";
import Heading from "../../components/Heading";

import "./ActRoster.css";
import { ProfileRelationType, ProfileType } from "../../types/enum";
import ActList from "../../components/acts/ActList";
import { withStyles } from "@material-ui/core/styles";

const styles = theme => ({
    tabBadge: {
        padding: "0 4px",
        display: "inline-flex",
        alignItems: "center",
        gap: "8px"
    },
    badge: {
        position: "static",
        transform: "none",
        backgroundColor: "#ff9800",
        color: "white"
    },
    badgeHighlight: {
        position: "static",
        transform: "none",
        backgroundColor: "#f44336",
        color: "white",
        animation: "pulse 2s infinite"
    }
});

@inject("profileStore", "agentActStore", "userInvitationStore")
@withRouter
@observer
class ActRoster extends Component {
    state = {
        tabValue: 0,
        mainTabValue: 0,
    };

    componentDidMount = () => {
        this.props.agentActStore.setIsAgentAct(false);
        this.props.agentActStore.resetAgentActs();
        this.props.profileStore.loadProfiles().then(() => {
            this.profile = this.props.profileStore.getCurrentProfile();
            this.props.agentActStore.getAgentsPendingRequest();
            this.props.agentActStore.getAgentActRosterWithPagination(this.profile?.id, 1);
            this.props.userInvitationStore.getMyUserInvitation(ProfileRelationType.AgentAct.ordinal);
        });

        if (this.props && this.props.match && this.props.match.params && this.props.match.params.tab) {
            const tab = this.props.match.params.tab;
            if (tab === "default" || tab === "roster") {
                this.setState({ tabValue: 0 });
            } else if (tab === "exclusive" || tab === "myact") {
                this.setState({ tabValue: 1 });
            } else if (tab === "invited") {
                this.setState({ tabValue: 2 });
            } else if (tab === "applications") {
                this.setState({ tabValue: 3 });
            }
        }
    };

    renderTabComponent = () => {
        const { tabValue } = this.state;

        switch (tabValue) {
            case 0:
                return <AgentActRoster />;
            case 1:
                return (
                    <div style={{ paddingTop: 30, paddingLeft: 30, paddingBottom: 10 }}>
                        <ActList agentAct />
                    </div>
                );
            case 2:
                return <InvitedActsTable />;
            case 3:
                return <ApplyToPlayTable />;
            default:
                return "";
        }
    };

    handleTabChange = (event, value) => {
        switch (value) {
            case 0:
                this.props.history.replace("/agent/actroster");
                break;
            case 1:
                this.props.history.replace("/agent/actroster/exclusive");
                break;
            case 2:
                this.props.history.replace("/agent/actroster/invited");
                break;
            case 3:
                this.props.history.replace("/agent/actroster/applications");
                break;
            default:
                this.props.history.replace("/agent/actroster");
                break;
        }

        this.setState({
            tabValue: value
        });
    };

    openActInvitationModal = () => {
        this.props.agentActStore.openActInvitationModal();
    };

    closeActInvitationModal = () => {
        this.props.agentActStore.closeActInvitationModal();
    };

    getInvitedCount = () => {
        const { invitations } = this.props.userInvitationStore;
        return invitations.filter(inv => !inv.additionalData).length;
    };

    getApplicationsCount = () => {
        const { invitations } = this.props.userInvitationStore;
        const { pendingAgentActs } = this.props.agentActStore;
        const invitationApps = invitations.filter(inv => inv.additionalData).length;
        const pendingApps = pendingAgentActs.filter(p => p.primaryProfile?.type === ProfileType.Act.ordinal).length;
        return invitationApps + pendingApps;
    };

    render() {
        const { isLoading } = this.state;
        const { classes } = this.props;
        var currentProfile = this.props.profileStore.getCurrentProfile();
        const invitedCount = this.getInvitedCount();
        const applicationsCount = this.getApplicationsCount();

        return (
            <main>
                <Header />
                <Sidebar />
                <MainContainer>
                    <Heading title="My Act Roster">
                        {this.state.tabValue === 1 ?
                            (currentProfile?.isConsultant ? null : 
                                <Button 
                                    id="btn-invite-act2" 
                                    variant="contained" 
                                    color="primary" 
                                    style={{color: 'white'}} 
                                    onClick={() => this.props.agentActStore.setIsAgentAct(true)} 
                                    className="pull-right" 
                                    component={Link} 
                                    to="/myact/create"
                                >
                                    Create Act
                                </Button>
                            )
                            :
                            <Button 
                                id="btn-invite-act2" 
                                variant="contained" 
                                color="primary" 
                                className="pull-right" 
                                onClick={this.openActInvitationModal}
                            >
                                Add Act
                            </Button>
                        }
                    </Heading>
                    <Paper style={{ position: "relative" }}>
                        <AppBar position="static" elevation={2} style={{ backgroundColor: "#3A3B3D" }}>
                            <Tabs 
                                value={this.state.tabValue} 
                                onChange={this.handleTabChange} 
                                indicatorColor="primary" 
                                textColor="secondary"
                                scrollable
                                scrollButtons="off"
                                classes={{
                                    root: "tabs-root",
                                    indicator: "tabs-indicator"
                                }}
                            >
                                <Tab 
                                    value={0} 
                                    label="Agency Act Roster" 
                                    classes={{ selected: "tab-selected" }} 
                                />
                                <Tab 
                                    value={1} 
                                    label="Agency Exclusive Acts" 
                                    classes={{ selected: "tab-selected" }} 
                                />
                                <Tab 
                                    value={2} 
                                    label={
                                        <span className={classes.tabBadge}>
                                            Invited Acts
                                            {invitedCount > 0 && (
                                                <Badge 
                                                    badgeContent={invitedCount} 
                                                    color="primary"
                                                    classes={{ badge: classes.badge }}
                                                />
                                            )}
                                        </span>
                                    } 
                                    classes={{ selected: "tab-selected" }} 
                                />
                                <Tab 
                                    value={3} 
                                    label={
                                        <span className={classes.tabBadge}>
                                            Applications
                                            {applicationsCount > 0 && (
                                                <Badge 
                                                    badgeContent={applicationsCount} 
                                                    color="secondary"
                                                    classes={{ badge: classes.badgeHighlight }}
                                                />
                                            )}
                                        </span>
                                    } 
                                    classes={{ selected: "tab-selected" }} 
                                />
                            </Tabs>
                        </AppBar>
                        {!this.profile?.festivalCode && this.renderTabComponent()}
                    </Paper>

                    {this.profile?.festivalCode && (
                        <Paper style={{ position: "relative" }} className="booking-paper-form">
                            <Loading showed={isLoading} />
                            <div style={{ padding: 16 }}>
                                <Hidden smDown>
                                    <AppBar position="static" elevation={2} style={{ backgroundColor: "#3A3B3D" }}>
                                        <Tabs
                                            value={this.state.tabValue}
                                            onChange={this.handleTabChange}
                                            indicatorColor="primary"
                                            textColor="secondary"
                                            scrollable
                                            scrollButtons="off"
                                            classes={{
                                                root: "tabs-root",
                                                indicator: "tabs-indicator"
                                            }}
                                        >
                                            <Tab label="All Acts" classes={{ selected: "tab-selected" }} />
                                            <Tab label={`${this.profile?.festivalTitle} Acts`} classes={{ selected: "tab-selected" }} />
                                        </Tabs>
                                    </AppBar>
                                    <br />
                                </Hidden>
                                {this.renderTabComponent()}
                            </div>
                        </Paper>
                    )}
                </MainContainer>
            </main>
        );
    }
}

export default withStyles(styles)(ActRoster);
